import { render, staticRenderFns } from "./TreeWall.vue?vue&type=template&id=2129f152&"
import script from "./TreeWall.vue?vue&type=script&lang=ts&"
export * from "./TreeWall.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports